import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { observable, computed } from 'mobx';
import { autobind } from 'core-decorators';
import ZtServiceFactory from '@src/services/zt';
import qs from '@xfe-team/utils/src/query-string-util';
import { useEffect } from 'react';
import { useRootStore } from '@src/mobx-store/root-store';
import useMount from '../hooks/use-mount';
import { noop } from '../common-util';

class BaseStore {
  $globalStore;

  $history;
  /**
   * store中初始化service接口变量
   */
  $ztService = ZtServiceFactory.getDefaultInstance();

  $props;

  @observable isJinShanLogin = false;

  /**
   * 当前登录账号
   * @returns {undefined|*}
   */
  @computed
  get currentLoginAccount() {
    if (window.XPASS && window.XPASS.u_account) {
      return window.XPASS.u_account;
    } else {
      return undefined;
    }
  }

  /**
   * 跳转至具体的路由
   * @param {string} url - 跳转路由地址
   * @param {boolean} [isReplace] - 是否替换
   */
  @autobind
  redirect(url, isReplace = false) {
    if (isReplace) {
      this.$history.replace(url);
    } else {
      this.$history.push(url);
    }
  }

  /**
   * 创建 search params 参数
   * @private
   */
  _createSearchParams() {
    let { search = '' } = this.$history.location;
    search = search.replace(/^\?/, '');
    useEffect(
      () => {
        if (search) {
          this.$searchParams = qs.parse(search);
        } else {
          this.$searchParams = {};
        }
      },
      [search]
    );
  }

  @autobind
  exitAccount() {
    if (window.XPASS) {
      window.XPASS.exit(() => {
        window.location.reload();
      });
    }
  }

  @autobind
  login({ onLoginSuccess = noop } = {}) {
    window.XPASS.signin({
      onLoginSuccess: e => {
        onLoginSuccess(e);
      }
    });
  }

  getJinShanLoginStatus() {
    clearInterval(this._jinShanLoginStatusTimer);
    this._jinShanLoginStatusTimer = setInterval(() => {
      if (window.XPASS?.u_account) {
        clearInterval(this._jinShanLoginStatusTimer);
        this?.$globalStore?.authServise?.setAccountInfo?.();
        this.isJinShanLogin = true;
      }
    }, 200);
    return () => {
      clearInterval(this._jinShanLoginStatusTimer);
    };
  }

  use(props) {
    this.$globalStore = useRootStore().globalStore;

    this.$props = props || {};
    this.$history = useHistory();

    /**
     * 路由参数
     * @type {History}
     */
    this.$routeParams = useParams();
    this.$routeMatch = useRouteMatch();
    this._createSearchParams();

    useMount(() => {
      const clearTimer = this.getJinShanLoginStatus();

      return () => {
        clearTimer();
      };
    });
  }
}

export default BaseStore;
